import { isArray, snakeCase } from 'lodash-es';
import { deepConvertKey } from './lodashExtend';

export const objectToFormData = (obj: any) => {
  const formData = new FormData();

  obj = deepConvertKey(obj, snakeCase);

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (isArray(obj[key])) {
        obj[key].forEach((item: any) => {
          formData.append(`${key}[]`, item);
        });
      } else {
        formData.append(key, obj[key] + '');
      }
    }
  }

  return formData;
};
